export const mahjong_culture = [
  // --- 三元牌 (三元及第) ---
  { char: '🀄', name: 'Mahjong Red Dragon', nameZh: '紅中/中獎', keywords: ['win', 'hit', 'success', 'luck', '紅中', '命中'], hot: true },
  { char: '🀅', name: 'Mahjong Green Dragon', nameZh: '發財/大發', keywords: ['wealth', 'money', 'start', 'luck', '發財', '大發'], hot: true },
  { char: '🀆', name: 'Mahjong White Dragon', nameZh: '白板/純粹', keywords: ['clear', 'empty', 'pure', 'minimalist', '白板', '空白'] },

  // --- 四風牌 (呼風喚雨) ---
  { char: '🀀', name: 'Mahjong East Wind', nameZh: '東風/開局', keywords: ['east', 'wind', 'start', '東風'] },
  { char: '🀁', name: 'Mahjong South Wind', nameZh: '南風', keywords: ['south', 'wind', '南風'] },
  { char: '🀂', name: 'Mahjong West Wind', nameZh: '西風', keywords: ['west', 'wind', '西風'] },
  { char: '🀃', name: 'Mahjong North Wind', nameZh: '北風', keywords: ['north', 'wind', '北風'] },

  // --- 萬子 (1-9) ---
  { char: '🀇', name: 'Mahjong One Wan', nameZh: '一萬', keywords: ['one', 'money', '萬'] },
  { char: '🀈', name: 'Mahjong Two Wan', nameZh: '二萬', keywords: ['two', '萬'] },
  { char: '🀉', name: 'Mahjong Three Wan', nameZh: '三萬', keywords: ['three', '萬'] },
  { char: '🀊', name: 'Mahjong Four Wan', nameZh: '四萬', keywords: ['four', '萬'] },
  { char: '🀋', name: 'Mahjong Five Wan', nameZh: '五萬', keywords: ['five', '萬'] },
  { char: '🀌', name: 'Mahjong Six Wan', nameZh: '六萬', keywords: ['six', '萬'] },
  { char: '🀍', name: 'Mahjong Seven Wan', nameZh: '七萬', keywords: ['seven', '萬'] },
  { char: '🀎', name: 'Mahjong Eight Wan', nameZh: '八萬', keywords: ['eight', '萬'] },
  { char: '🀏', name: 'Mahjong Nine Wan', nameZh: '九萬', keywords: ['nine', '萬'] },

  // --- 筒子 (1-9) ---
  { char: '🀙', name: 'Mahjong One Dot', nameZh: '一筒', keywords: ['dot', 'circle', 'one'] },
  { char: '🀚', name: 'Mahjong Two Dot', nameZh: '二筒', keywords: ['dot', 'circle', 'two'] },
  { char: '🀛', name: 'Mahjong Three Dot', nameZh: '三筒', keywords: ['dot', 'circle', 'three'] },
  { char: '🀜', name: 'Mahjong Four Dot', nameZh: '四筒', keywords: ['dot', 'circle', 'four'] },
  { char: '🀝', name: 'Mahjong Five Dot', nameZh: '五筒', keywords: ['dot', 'circle', 'five'] },
  { char: '🀞', name: 'Mahjong Six Dot', nameZh: '六筒', keywords: ['dot', 'circle', 'six'] },
  { char: '🀟', name: 'Mahjong Seven Dot', nameZh: '七筒', keywords: ['dot', 'circle', 'seven'] },
  { char: '🀠', name: 'Mahjong Eight Dot', nameZh: '八筒', keywords: ['dot', 'circle', 'eight'] },
  { char: '🀡', name: 'Mahjong Nine Dot', nameZh: '九筒', keywords: ['dot', 'circle', 'nine'] },

  // --- 條子 (1-9) ---
  { char: '🀐', name: 'Mahjong One Bamboo', nameZh: '一條/小鳥', keywords: ['bird', 'bamboo', 'one', '小鳥'] },
  { char: '🀑', name: 'Mahjong Two Bamboo', nameZh: '二條', keywords: ['bamboo', 'two'] },
  { char: '🀒', name: 'Mahjong Three Bamboo', nameZh: '三條', keywords: ['bamboo', 'three'] },
  { char: '🀓', name: 'Mahjong Four Bamboo', nameZh: '四條', keywords: ['bamboo', 'four'] },
  { char: '🀔', name: 'Mahjong Five Bamboo', nameZh: '五條', keywords: ['bamboo', 'five'] },
  { char: '🀕', name: 'Mahjong Six Bamboo', nameZh: '六條', keywords: ['bamboo', 'six'] },
  { char: '🀖', name: 'Mahjong Seven Bamboo', nameZh: '七條', keywords: ['bamboo', 'seven'] },
  { char: '🀗', name: 'Mahjong Eight Bamboo', nameZh: '八條', keywords: ['bamboo', 'eight'] },
  { char: '🀘', name: 'Mahjong Nine Bamboo', nameZh: '九條', keywords: ['bamboo', 'nine'] },

  // --- 花與四季 ---
  { char: '🀢', name: 'Mahjong Plum', nameZh: '梅', keywords: ['flower', 'plum'] },
  { char: '🀣', name: 'Mahjong Orchid', nameZh: '蘭', keywords: ['flower', 'orchid'] },
  { char: '🀤', name: 'Mahjong Bamboo', nameZh: '竹', keywords: ['flower', 'bamboo'] },
  { char: '🀥', name: 'Mahjong Chrysanthemum', nameZh: '菊', keywords: ['flower', 'chrysanthemum'] },
  { char: '🀦', name: 'Mahjong Spring', nameZh: '春', keywords: ['season', 'spring'] },
  { char: '🀧', name: 'Mahjong Summer', nameZh: '夏', keywords: ['season', 'summer'] },
  { char: '🀨', name: 'Mahjong Autumn', nameZh: '秋', keywords: ['season', 'autumn'] },
  { char: '🀩', name: 'Mahjong Winter', nameZh: '冬', keywords: ['season', 'winter'] },
];